import { useRouter } from 'next/router'
import React, { useContext } from 'react'

import HNContext from '@/context/HNContext'
import type { IRootData } from '@/types/organization'

import BelcoChat from './BelcoChat'
import CrispChat from './CrispChat'
import DriftChat from './DriftChat'
import FreshChat from './FreshChat'
import Helpscout from './Helpscout'
import HubSpot from './HubSpot'
import Intercom from './Intercom'
import TidioChat from './TidioChat'
import TrengoChat from './TrengoChat'

export default function ChatSnippets() {
  const { organization, organizationSetting, userProfile } = useContext(
    HNContext
  ) as IRootData
  const router = useRouter()
  if (!organization || !organizationSetting) return <></>
  if (userProfile && userProfile.is_csm_of_organization) return <></>

  if (
    !router.pathname.includes('/admin') &&
    !router.pathname.includes('/embed') &&
    !router.pathname.includes('/postwidget') &&
    !router.pathname.includes('/submission_only') &&
    !router.pathname.includes('/changelogwidget') &&
    !router.pathname.includes('/submission_form_with_key')
  ) {
    return (
      <>
        <Intercom appId={organizationSetting.intercom_app_id || ''} />
        <CrispChat appId={organizationSetting.crisp_chat_app_id || ''} />
        <HubSpot appId={organizationSetting.hub_spot_app_id || ''} />
        <TidioChat appId={organizationSetting.tidio_app_id || ''} />
        <FreshChat appId={organizationSetting.freshchat_app_id || ''} />
        <DriftChat appId={organizationSetting.drift_app_id || ''} />
        <BelcoChat appId={organizationSetting.belco_app_id || ''} />
        <TrengoChat appId={organizationSetting.trengo_app_id || ''} />
        <Helpscout appId={organizationSetting.helpscout_app_id || ''} />
      </>
    )
  }
  return <></>
}
